import { takeLatest, put, call } from 'redux-saga/effects';
import {
    GET_STATES_LIST,
    getStatesListSuccess,
    getStatesListFailure,
    GET_EDIT_DATA,
    getEditDataSuccess,
    getEditDataFailure,
    fetchEwsSelectPlanNameSuccess,
    fetchEwsSelectPlanNameFailure

} from './action';
import { HTTP_HEADERS } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import * as corporateOnboardingAction from './action';
import { REPORT, SCORE_DEFINATION, CORE_API, AUTH_SERVER, EWS_API } from '../../../config';

export function* getInactiveCorporateUserFunc(action) {

    let requestUrl = `${AUTH_SERVER}/user/inactive/corporate/list/${action.data}`;
    try {
        const createResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(getInactiveCorporateUserSuccess(createResult.data));
    } catch (err) {
        yield put(getInactiveCorporatesUserFailure(err))
    }
}

export function* getInactiveCorporateUserSaga() {
    yield takeLatest(GET_INACTIVE_CORPORATE_USER_LIST, getInactiveCorporateUserFunc);
}

export function* enableInactiveCorporateUser(action) {
    let requestURL = `${AUTH_SERVER}/user/reactivate/${action.data}`;
    try {
        yield call(request, requestURL, { data: action.data, method: 'PUT', headers: HTTP_HEADERS });
        //request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS }
        yield put(enableCorporateUserSuccess());

    } catch (err) {
        yield put(enableCorporateUserFailure(err))
    }
}
export function* enableCorporateUserSaga() {
    yield takeLatest(ENABLE_CORPORATE_USER, enableInactiveCorporateUser);
}

export function* transferCorporateUser(action) {
    let requestUrl = `${AUTH_SERVER}/user/transfer/${action.data.id}/${action.data.corporateId}`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'PUT', headers: HTTP_HEADERS });
        yield put(transferCorporateUserSuccess(createResult.data));
    } catch (err) {
        yield put(transferCorporateUserFailure(err))
    }
}

export function* transferCorporateUserSaga() {
    yield takeLatest(TRANSFER_CORPORATE_USER, transferCorporateUser);
}


export function* getEditDataFunc(action) {

    let requestUrl = `${CORE_API}/onboarding/edit/${action.data}`;
    try {
        const createResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(getEditDataSuccess(createResult));
    } catch (err) {
        yield put(getEditDataFailure(err))
    }
}

export function* getEditData() {
    yield takeLatest(GET_EDIT_DATA, getEditDataFunc);
}

export function* getStatesListFunc(action) {

    let requestUrl = `${CORE_API}/counterparty/states`;
    try {
        const createResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(getStatesListSuccess(createResult));
    } catch (err) {
        yield put(getStatesListFailure(err))
    }
}
export function* getStatesList() {
    yield takeLatest(GET_STATES_LIST, getStatesListFunc);
}

export function* getProductSectionList() {
    let requestUrl = `${REPORT}/section/onboarding/list`;
    try {
        const productsectionList = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(corporateOnboardingAction.fetchSectionListSuccess(productsectionList.data))
    }
    catch (err) {
        yield put(corporateOnboardingAction.fetchSectionListFailure(err))
    }
}
export function* fetchProductSectionList() {
    yield takeLatest(corporateOnboardingAction.FETCH_PRODUCT_SECTION_LIST, getProductSectionList);
}

export function* getCreditLimitModelList() {
    let requestUrl = `${SCORE_DEFINATION}/creditlimit/model/list`;
    try {
        const creditModelList = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(corporateOnboardingAction.fetchCreditLimitModelListSuccess(creditModelList.data))
    }
    catch (err) {
        yield put(corporateOnboardingAction.fetchCreditLimitModelListFailure(err))
    }
}
export function* fetchCreditLimitModelList() {
    yield takeLatest(corporateOnboardingAction.FETCH_CREDIT_LIMIT_MODEL_LIST, getCreditLimitModelList);
}

/* export function* fetchRiskcategoryList(action) {
    let requestUrl = `${SCORE_DEFINATION}/scorecard/risklevels`;
    try {
        const riskcategoryList = yield call(request, requestUrl, {  method: 'GET', headers: HTTP_HEADERS });
        yield put(corporateOnboardingAction.fetchRiskgradeCategorySuccess(riskcategoryList.data))
    }
    catch (err) {
        yield put(corporateOnboardingAction.fetchRiskgradeCategoryFailure(err))
    }
}
export function* fetchRiskcategory() {
    yield takeLatest(corporateOnboardingAction.FETCH_RISKGRADE_CATEGORY_LIST, fetchRiskcategoryList);
} */

export function* fetchRiskfactorList(action) {
    let requestUrl = `${SCORE_DEFINATION}/riskfactor/onboarding/list`;
    try {
        const riskfactorList = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(corporateOnboardingAction.fetchRiskfactorsSuccess(riskfactorList.data))
    }
    catch (err) {
        yield put(corporateOnboardingAction.fetchRiskfactorsFailure(err))
    }
}
export function* fetchRiskfactor() {
    yield takeLatest(corporateOnboardingAction.FETCH_RISKFACTORS, fetchRiskfactorList);
}

export function* postCorporateOnboardingData(action) {
    let requestUrl = `${CORE_API}/onboarding/`;
    try {
        const onboardingData = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(corporateOnboardingAction.CorporateOnboardingSuccess(onboardingData.data))
    }
    catch (err) {
        yield put(corporateOnboardingAction.CorporateOnboardingFailure(err))
    }
}
export function* corporateOnboardingData() {
    yield takeLatest(corporateOnboardingAction.CORPORATE_ONBOARDING, postCorporateOnboardingData);
}

export function* putcorporateOnboardingDataEdit(action) {
    let requestUrl = `${CORE_API}/onboarding/`;
    try {
        const editedOnboardingData = yield call(request, requestUrl, { data: action.data, method: 'PUT', headers: HTTP_HEADERS });
        yield put(corporateOnboardingAction.corporateOnboardingEditSuccess(editedOnboardingData.data))
    }
    catch (err) {
        yield put(corporateOnboardingAction.corporateOnboardingEditFailure(err))
    }
}
export function* corporateOnboardingDataEdit() {
    yield takeLatest(corporateOnboardingAction.CORPORATE_ONBOARDING_EDIT, putcorporateOnboardingDataEdit);
}

export function* oneClickCorporateOnboardSaga(action) {
    let requestUrl = `${CORE_API}/onboarding/oneclickonboard`;
    try {
        const searchResult = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(corporateOnboardingAction.oneClickCorporateOnboardingSuccess(searchResult.data));
    } catch (err) {
        yield put(corporateOnboardingAction.oneClickCorporateOnboardingFailure(err))
    }
}
export function* oneClickCorporateOnboarding() {
    yield takeLatest(corporateOnboardingAction.ONE_CLICK_CORPORATE_ONBOARDING, oneClickCorporateOnboardSaga);
}

export function* addDefaultProductsSaga(action) {
    let requestUrl = `${CORE_API}/onboarding/add/defaultproducts`;
    try {
        const searchResult = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(corporateOnboardingAction.addDefaultProductsSuccess(searchResult.data));
    } catch (err) {
        yield put(corporateOnboardingAction.addDefaultProductsFailure(err))
    }
}
export function* addDefaultProducts() {
    yield takeLatest(corporateOnboardingAction.ADD_DEFAULT_PRODUCTS, addDefaultProductsSaga);
}

export function* fetchMisFieldsSaga() {
    let requestUrl = `${CORE_API}/misfield/list`;
    try {
        const misFieldList = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(corporateOnboardingAction.fetchMisFieldsSuccess(misFieldList.data))
    }
    catch (err) {
        yield put(corporateOnboardingAction.fetchMisFieldsFailure(err))
    }
}
export function* fetchMisFields() {
    yield takeLatest(corporateOnboardingAction.FETCH_MIS_FIELDS, fetchMisFieldsSaga);
}

export function* fetchIsMisOrderIdMandatoryByCorporateIdSaga(action) {
    let requestUrl = `${CORE_API}/misfield/isMisOrderIdMandatory/${action.data}`;
    try {
        const misFieldList = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(corporateOnboardingAction.fetchIsMisOrderIdMandatoryByCorporateIdSuccess(misFieldList.data))
    }
    catch (err) {
        yield put(corporateOnboardingAction.fetchIsMisOrderIdMandatoryByCorporateIdFailure(err))
    }
}
export function* fetchIsMisOrderIdMandatoryByCorporateId(data) {
    yield takeLatest(corporateOnboardingAction.FETCH_IS_MANDATORY_MIS_ORDERID_BY_CORPORATE, fetchIsMisOrderIdMandatoryByCorporateIdSaga);
}


export function* fetchMisFieldsByCorporateIdSaga(action) {
    let requestUrl = `${CORE_API}/misfield/fetch/${action.data}`;
    try {
        const misFieldList = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(corporateOnboardingAction.setMisFieldSetup(misFieldList.data))
    }
    catch (err) {
        yield put(corporateOnboardingAction.fetchMisFieldsByCorporateIdFailure(err))
    }
}

export function* fetchMisFieldsByCorporateId(data)
{
    yield takeLatest(corporateOnboardingAction.FETCH_MIS_FIELDS_BY_CORPORATE_ID,fetchMisFieldsByCorporateIdSaga);
}


export function* fetchDefaultMisFieldsSaga() {
   let requestUrl = `${CORE_API}/misfield/default/list`;
    try {
        const defaultMisFieldList = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(corporateOnboardingAction.fetchDefaultMisFieldsSuccess(defaultMisFieldList.data))
    }
    catch (err) {
        yield put(corporateOnboardingAction.fetchDefaultMisFieldsFailure(err))
    }
}
export function* fetchDefaultMisFields() {
    yield takeLatest(corporateOnboardingAction.FETCH_DEFAULT_MIS_FIELDS, fetchDefaultMisFieldsSaga);
}

export function* fetchEwsSelectPlanNameSaga() {
    let requestUrl = `${EWS_API}/plan/all`;
    try {
        const ewsSelectPlanNameList = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(corporateOnboardingAction.fetchEwsSelectPlanNameSuccess(ewsSelectPlanNameList.data))
    }
    catch (err) {
        yield put(corporateOnboardingAction.fetchEwsSelectPlanNameFailure(err))
    }
}
export function* fetchEwsSelectPlanName() {
    yield takeLatest(corporateOnboardingAction.FETCH_EWS_PLAN_NAME_LIST, fetchEwsSelectPlanNameSaga);
}